import { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import BreadCrumbs from '@components/Breadcrumbs'
import Button from '@components/Button'
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import Form from './Form';
import { apiClient } from '@services/api';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

const permissions = ['administrador'];

const Update = (props) => {
  document.title = `Editar detalhes do motorista - ${process.env.REACT_APP_NAME}`
  const { driver_id } = useParams();
  const history = useHistory();
  const [driver, setDriver] = useState({})
  const [error, setError] = useState(false);
  const [isEditing, setIsEditing] = useState(false)
  const [errorMessage, setErrorMessage] = useState("");
  let url = `/drivers/${driver_id}`;

  const bradecrumbsConfig = [
    {
      title: 'Início',
      active: true,
      route: '/admin/motoristas'
    },
    {
      title: `${driver.name !== undefined ? driver.name : ''}`,
      active: true,
      route: `/admin/motoristas/detalhe/${driver_id}`
    },
    {
      title: 'Edição',
    }
  ]

  const getDriverById = url => {
    apiClient
      .httpInstance.get(url)
      .then(response => {
        if (response.status === 200) {
          setDriver(response.data);
          setIsEditing(true)
        }
      }
      )
      .catch((error) => console.log(error));
  }

  const changeState = (ev) => {
    if (ev.target.name === "status" && ev.target.value === "true") {
      setDriver(
        {
          ...driver,
          status: true
        }
      )
    } else if (ev.target.name === "status" && ev.target.value === "false") {
      setDriver(
        {
          ...driver,
          status: false
        }
      )
    } else {
      setDriver(
        {
          ...driver,
          [ev.target.name]: ev.target.value
        }
      )
    }
  }

  const submitDriverEdit = (ev) => {
    ev.preventDefault();
    apiClient
      .httpInstance.put(`/drivers/${driver_id}`, {
        name: driver.name,
        email: driver.email,
        phone: driver.phone,
        address: driver.address,
        identification_document: driver.identification_document,
        license_type: driver.license_type,
        observation: driver.observation,
        status: driver.status
      })
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          history.push('/admin/motoristas');
        }
      })
      .catch(error => {
        if (error) {
          setError(true);
          setErrorMessage(error.response.message || "Erro inesperado, tente novamente mais tarde")
          setTimeout(() => { setError(false) }, 4000);
        }
      });
  }
  useEffect(() => {
    getDriverById(url);
  }, [url]);

  if (isEditing) {
    return <>
      <BreadCrumbs items={bradecrumbsConfig} />
      {error && (
        <Alert className="mb-5" variant="filled" severity="error">
          {errorMessage}
        </Alert>
      )}
      {permissions.includes(props?.theme?.permission) ?
        <div className="px-7 pt-6">
          <div className="flex items-center justify-between mt-2 text-2xl text-blue">
            <span>Edição</span>
            <Button
              extcolor="#e8f0fb"
              padding="6px 15px"
              width="200"
              variant="outlined"
              onClick={() => history.push(`/admin/motoristas/detalhe/${driver_id}`)}
              bgColor="transparent"
            >
              <Icon className="mr-2">
                arrow_back
              </Icon>
              Cancelar
            </Button>
          </div>
          <Form
            {...props}
            submit={submitDriverEdit}
            driver={driver}
            isEditing={isEditing}
            changeState={changeState}
          />
        </div>
        :
        <div className="px-7 pt-6">
          <div className="flex items-center justify-between mt-2 text-2xl text-blue">
            <span>Edição</span>
            <Button
              extcolor="#e8f0fb"
              padding="6px 15px"
              width="200"
              variant="outlined"
              onClick={() => history.push(`/admin/motoristas/detalhe/${driver_id}`)}
              bgColor="transparent"
            >
              <Icon className="mr-2">
                arrow_back
              </Icon>
              Cancelar
            </Button>
          </div>
          <div className="mt-4 bg-white text-blue font-poppins" style={{ borderRadius: '10px' }}>
            Você não possui permissão para acessar este recurso.
          </div>
        </div>
      }
    </>
  } else {
    return <>
    </>
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(Update);
